import {
  FileDescriptor,
  LayoutDefinition,
  NewAnimationId,
  NewSceneAnimation,
  NewTextAnimation,
  SceneCell,
  ShapeConfig,
} from '../../../../../elements/resource/types/shape.type';
import {
  _screenX,
  _screenY,
} from '../../../../../services/canvas/canvas.service';
import { TextShape } from '../../text/text-shape';
import { RootShape } from './root-shape';
import { setDescriptorValue } from '../../../../store/editor.crud.actions';
import gsap from 'gsap';
import { ShapeService } from '../../../shape.service';
import { ResourceData } from '../../../../../elements/resource/resource.types';
import { cloneDeep, isEqual } from 'lodash';
import { ContainerAnimationId, ShapeCell } from './shape-cell';
import { selectFileDescriptor } from '../../../../store/selector/editor.selector';
import { ImageAnimationId, ImageShape } from '../../base/image-shape';
import { TextAnimationStep } from '../../../../animation/text-animation.service';
import { GloveDefinition } from '../../../background.service';
export class FileRootShape extends RootShape<FileDescriptor> {
  newAnimation: NewSceneAnimation;
  get sceneType() {
    const contents = Object.values(this.descriptor?.content || {});
    // console.log('selectCurrentSceneType > contents', contents);
    switch (contents.length) {
      case 0:
        return 'none';
      case 1:
        const [first] = contents;
        if (first.text) {
          return 'text';
        } else if (first.imageUrl) {
          return 'image';
        } else if (first.videoUrl) {
          return 'video';
        } else {
          return 'none';
        }
      default:
        return 'container';
    }
  }

  content: FileDescriptor['content'];

  textAnimationStep: TextAnimationStep;

  constructor(
    service: ShapeService,
    data: ResourceData<FileDescriptor>,
    config?: ShapeConfig,
  ) {
    super(service, data, config);

    this.service.store
      .select(selectFileDescriptor(this.IRI))
      .subscribe(descriptor => {
        if (!descriptor) {
          return;
        }

        if (isEqual(this.descriptor, descriptor)) {
          return;
        }

        this.descriptor = cloneDeep(descriptor);
        this.setGloveActionsInOrder();
        this.textAnimationStep = this.descriptor.textAnimationStep;
        // Apply reactive updates driven by descriptor changes
        this.content = this.descriptor.content;
        this.initCells();
        this.applyTextColorToCells();
      });
  }

  applyTextColorToCells() {
    const color = this.descriptor?.textColor;
    if (!color) {
      return;
    }
    Object.values(this.shapeCells || {}).forEach(cell => {
      const ts = cell?.ts;
      if (ts) {
        const prevFill = ts.descriptor.svgAttributes?.fill;
        ts.descriptor.svgAttributes = {
          ...(ts.descriptor.svgAttributes || {}),
          fill: { ...(prevFill || {}), color },
        };
        ts.refreshElement();
      }
    });
  }

  regenerateAnimation() {
    this.revertSceneAnimation();
    switch (this.newAnimation.type) {
      case 'plain-text':
        this.newAnimation.animation = this.animationService.regenerateAnimation(
          this.newAnimation.animation as NewTextAnimation,
          {
            words: (this.shapes[0] as TextShape).words,
          },
        );
        this.saveDescriptorKey(
          'newAnimationId',
          (this.newAnimation.animation as NewTextAnimation).id,
          true,
        );
        break;
    }
  }

  reset(): void {
    this._show();
    this.rootContainer.alpha = 1;
    this.rootContainer.position.set(0, 0);
    // this.backgroundService.reset();
    this.shapes.map((shape: TextShape | ImageShape) => shape.reset());
    this.next?.reset();
  }
  revertSceneAnimation() {
    switch (this.newAnimation.type) {
      case 'plain-text':
        const [textShape] = this.shapes;
        // -- //
        (textShape as TextShape).refreshElement();
        // (textShape as TextShape)._show();
        (textShape as TextShape).reAlignInCell();

        break;
    }
  }

  revertTextAnimation() {
    const [textShape] = this.shapes;
    (textShape as TextShape).refreshElement();
    // (textShape as TextShape)._show();
    (textShape as TextShape).reAlignInCell();
  }

  _setTextAnimation(step: TextAnimationStep) {}

  setTextAnimation(id: NewAnimationId) {
    const textShape = this.shapes[0] as TextShape;

    const animation = this.animationService.getNewTextAnimationById(id, {
      words: (this.shapes[0] as TextShape).words,
    });

    console.log('setTextAnimation', animation);
    // run the animation //
    // const timeLine = textShape.gsapAnimateNew(animation);
    // -- // -- // -- //
    this.store.dispatch(
      setDescriptorValue({
        IRI: this.IRI,
        key: 'textAnimation',
        value: animation,
        direct: true,
      }),
    );

    // timeLine.eventCallback('onComplete', () => {
    //   Object.values(this.shapeCells)[0].realignTs();
    // });
  }

  setImageAnimation(id: ImageAnimationId) {
    // -- //
    const imageShape = this.shapes[0] as ImageShape;
    const animation = this.animationService.getNewImageAnimationById(id);
    const timeLine = imageShape.gsapAnimateNew(animation);

    this.store.dispatch(
      setDescriptorValue({
        IRI: this.IRI,
        key: 'imageAnimation',
        value: animation,
        direct: true,
      }),
    );

    timeLine.eventCallback('onComplete', () => {
      // TODO - implement realign
      // Object.values(this.shapeCells)[0].realignTs();
    });
  }

  setContainerAnimation(id: ContainerAnimationId) {
    const cellsByX = Object.values(this.shapeCells).sort(
      (a, b) => a.cell.x - b.cell.x,
    );

    const timeline = gsap.timeline();
    cellsByX.map((cell, index) => {
      timeline.add(cell.appearAnimation(cellsByX.length, index), 0);
    });

    return timeline;
  }

  executeContainerAnimation(id?: ContainerAnimationId) {
    const cellsByX = Object.values(this.shapeCells).sort(
      (a, b) => a.cell.x - b.cell.x,
    );

    const timeline = gsap.timeline();
    cellsByX.map((cell, index) => {
      timeline.add(
        cell.appearAnimation(cellsByX.length, index),
        index == 0 ? 0 : `-=0.3`,
      );
    });
    return timeline;
  }

  setBackground() {
    // console.log('setBackground', this.descriptor.backgroundDefinitionId); //
    this.backgroundService._setBackgroundByTime(
      this.descriptor.backgroundDefinitionId,
      this.animationStartTime,
    );
    // -- // -- //
  }
  setThumbnailBackground() {
    this.backgroundService._setThumbnailBackgroundByTime(
      this.descriptor.backgroundDefinitionId,
      this.animationStartTime || 0,
    );
  }
  bgAnimationsByTime: Record<number, Record<string, GloveDefinition>> = {};
  gsapAnimate(timeline?: gsap.core.Timeline): gsap.core.Timeline {
    // const timeline = gsap.timeline();

    // switch (this.sceneType) {
    //   case 'text':
    //     break;

    //   case 'image':
    //     break;
    //   case 'video':
    //     break;

    //   case 'container':
    //     const containerTimeline = this.executeContainerAnimation();
    //     timeline.add(containerTimeline, 0);
    //     break;

    // }
    // return cell.gsapAnimate(0, 1); // -- // -- // -- //

    if (this.descriptor.textAnimationStep) {
      const { overlap } = this.descriptor.textAnimationStep;

      const textTimeline = this.gsapAnimateStep(
        this.descriptor.textAnimationStep,
      );

      textTimeline.eventCallback('onStart', () => {
        // console.log('on-start', this.descriptor.backgroundDefinitionId);
        this.cs.canvasContainer.addChild(this.rootContainer);
        this.backgroundService.setById(
          this.descriptor.backgroundDefinitionId,
          true,
        );
      });

      // TODO - add delay | overlap
      this.animationService.timeLine.add(
        textTimeline,
        overlap ? `-=${overlap}` : undefined,
      );

      // timeline.add(textTimeline);
      // this.backgroundService._gsAnimate(
      //   this.descriptor.backgroundDefinitionId,
      //   this.animationStartTime,
      //   this.animationStartTime +
      //     (this.descriptor.textAnimationStep.duration || 1),
      // );
      return textTimeline;
    }

    // TODD
    // if (this.descriptor.imageAnimation) {
    //   const imageTimeline = (this.shapes[0] as ImageShape).gsapAnimateNew(
    //     this.descriptor.imageAnimation,
    //   );
    //   timeline.add(imageTimeline, 0);
    // }

    // if (this.next) {
    //   const bgTimeLine = this.backgroundService.gsapAnimate(
    //     this.animationStartTime,
    //     this.next.animationStartTime,
    //   );
    //   timeline?.add(bgTimeLine, 0);
    // }

    return timeline;
  }

  gsapAnimateStep(step: TextAnimationStep) {
    const timeline = gsap.timeline();
    const timeScale = step.timeScale || 1;

    timeline.timeScale(timeScale);

    // this.rootContainer.scale.x = 1.05;
    // this.rootContainer.scale.y = 1.05;

    const { forEach, overlap, target, animationsByCell } = step;

    if (animationsByCell) {
      Object.entries(this.shapeCells).map(([id, cell]) => {
        const step = animationsByCell[id];
        if (!step) {
          return;
        }
        const { overlap, delay } = step;
        const cellTimeline = (
          (cell.ts as TextShape) || (cell.imageShape as ImageShape)
        ).gsapAnimateStep(step);
        timeline.add(cellTimeline, overlap ? `-=${overlap}` : delay || 0);
      });
    }
    // -- // -- //
    if (forEach) {
      const forEachTimeline = gsap.timeline();
      this.shapes
        .filter(shape => {
          if (target == 'text') {
            return shape.getType() == 'text-shape';
          }
          if (target == 'image') {
            return shape.getType() == 'image-shape';
          }
          return true;
        })
        .map((shape, index) => {
          const textTimeline = (
            shape as TextShape | ImageShape
          ).gsapAnimateStep(step);
          forEachTimeline.add(textTimeline, index * (overlap || 0));
        });

      timeline.add(forEachTimeline, `-=0.2`);
    } else {
      const textTimeline = (
        this.shapes[0] as TextShape | ImageShape
      ).gsapAnimateStep(step);
      timeline.add(textTimeline, 0);
    }

    // const baseBackground = this.backgroundService._gsAnimate(
    //   this.descriptor.backgroundDefinitionId,
    //   this.animationStartTime,
    //   this.animationStartTime + (step.duration || 1),
    // );

    // timeline.add(baseBackground, 0);

    return timeline;
  }

  initShapes(): void {
    const { aiContent } = this.descriptor;
    this.content = cloneDeep(this.descriptor.content) || {};

    this.shapesToBeLoaded = {};
    if (aiContent?.content) {
      const { type, content: text } = aiContent;

      let textValue: string;
      switch (type) {
        case 'list':
          textValue = text.join('\n');
          break;
        default:
          textValue = text;

          break;
      }
    } else {
      if (!this.descriptor.cells) {
        /*
        this.descriptor.cells = {
          'text-1': {
            x: 0,
            y: 0,
            w: 1,
            h: 1,
            widthRatio: 0.3,
          },
        };
        this.content = {
          'text-1': {
            text: 'Text',
          },
        };

        this.saveDescriptorKey('cells', this.descriptor.cells, true);
        */
      }
    }

    // -- // -- //
    this.initCells();
    // -- //
    this.waitForShapesToLoad();
    // this.gsapAnimate();

    this.setGloveActionsInOrder();
  }

  setGloveActionsInOrder() {
    const gloveActions = this.findBgGloveActions(
      this.descriptor.textAnimationStep,
    );
    // -- // -- //
    if (gloveActions.length) {
      this.gloveActionsInOrder = gloveActions
        .sort((a, b) => a.index - b.index)
        .map(a => a.action.bgGloveMotion);
      // console.log('gloveActionsInOrder', this.gloveActionsInOrder);
    }
  }

  gloveActionsInOrder: Record<string, GloveDefinition>[];

  findBgGloveActions(node: TextAnimationStep, path = '') {
    const results = [];

    // If the node is not an object, nothing to do
    if (node === null || typeof node !== 'object') return results;

    // ---- 1. Check if this node has an action with bgGloveMotion ----
    if (node.action && node.action.bgGloveMotion !== undefined) {
      results.push({
        index: node.action.index,
        //path: path ? path + '.action' : 'action',
        action: node.action,
      });
    }

    // ---- 2. Traverse all keys in this object ----
    for (const key of Object.keys(node)) {
      const value = node[key];

      if (Array.isArray(value)) {
        // Handle arrays (like parallel)
        value.forEach((item, index) => {
          const childPath = path
            ? `${path}.${key}[${index}]`
            : `${key}[${index}]`;
          results.push(...this.findBgGloveActions(item, childPath));
        });
      } else if (value !== null && typeof value === 'object') {
        // Handle nested objects
        const childPath = path ? `${path}.${key}` : key;
        results.push(...this.findBgGloveActions(value, childPath));
      }
    }

    return results;
  }

  initCells() {
    // -- // -- //
    this._shapes = [];
    // console.log('initCells', this.shapeCells);
    Object.values(this.shapeCells || {}).map(cell => cell.remove());
    this.shapeCells = {};
    Object.entries(this.descriptor.cells || {}).map(([id, cell]) => {
      this.shapeCells[id] = new ShapeCell(this, id, cell, this.content?.[id]);
    });
  }

  uploadFile(id: string, file: File) {
    // this.cs.httpService.saveFileToS3(file, id).then(() => {
    //   console.log('yooo -> image uploaded');
    // });
  }

  get newCellAlignment() {
    const margin =
      this.descriptor.margin == undefined ? 0.1 : this.descriptor.margin;

    const mx = _screenX * margin;
    const my = _screenY * margin;

    return {
      x: mx,
      y: my,
      w: this.cs._screenX - 2 * mx,
      h: this.cs._screenY - 2 * my,
    };
  }

  afterInit(): void {
    super.afterInit();

    const { x, y } = this.newCellAlignment;

    this.container.x = x;
    this.container.y = y;

    /* console.log(
      '--------- file-root-shape > afterInit ---------',
      this.descriptor,
    ); */

    // if (this.descriptor.newAnimation && false) {
    //   this.animationDuration = this.getAnimationTime(
    //     this.descriptor.newAnimation.animation,
    //   );
    //   console.log('animationDuration', this.animationDuration);
    //   // -- // -- // -- //---- //
    // } else if (this.descriptor.newAnimationId) {
    //   // -- //
    //   this.newAnimation = {
    //     type: 'plain-text',
    //     animation: this.animationService.getNewTextAnimationById(
    //       this.descriptor.newAnimationId,
    //     ),
    //   };
    //   this.animationDuration = this.getAnimationTime(
    //     this.newAnimation.animation,
    //   );
    // } else {
    //   this.saveDescriptorKey(
    //     'newAnimation',
    //     {
    //       baseType: 'appear',
    //       duration: 1.5,
    //       line: {
    //         // type: 'fade',
    //         translate: {
    //           from: 'top',
    //           distance: 1,
    //         },
    //       },
    //       word: {
    //         delay: 0.5,
    //         translate: {
    //           from: 'top',
    //           distance: 0.4,
    //         },
    //       },
    //       next: {
    //         baseType: 'disappear',
    //         duration: 0.5,
    //         line: {
    //           duration: 2,
    //           translate: {
    //             from: 'top',
    //             distance: 1,
    //           },
    //         },
    //         word: {
    //           translate: {
    //             from: 'top',
    //             distance: 0.4,
    //           },
    //         },
    //       },
    //     },
    //     true,
    //   );
    // }
  }

  cell: ShapeCell;
  shapeCells: Record<string, ShapeCell>;

  _setLayout(cells: SceneCell[]) {
    // First of all go for the dream

    // -- //
    console.log('setLayout', this.IRI);
    console.log('setLayout', cells, 'shapeCells', this.shapeCells);
    // -- //

    const idCounts = {
      text: 1,
      image: 1,
      video: 1,
    };

    this.descriptor.cells = cells.reduce((acc, cell) => {
      const id = `${cell.type}-${idCounts[cell.type]++}`;
      acc[id] = cell;

      if (!this.content[id]) {
        this.content[id] = {
          text: cell.type == 'text' ? 'undefined' : undefined,
          imageUrl: cell.type == 'image' ? 'undefined' : undefined,
          videoUrl: cell.type == 'video' ? 'undefined' : undefined,
        };
        console.log('----- setting content -----', this.content);
      }

      return acc;
    }, {});

    this.saveDescriptorKey('cells', this.descriptor.cells, true);
    this.saveDescriptorKey('content', this.content, true);

    console.log('descriptor.cells', this.descriptor.cells);
    this.initCells();
  }

  setLayout(def: LayoutDefinition) {
    // this.descriptor.layout = def;

    this.container.removeChildren();
    const [w, h] = [_screenX, _screenY];

    // this.cell = new ShapeCell(this, {
    //   x: 0,
    //   y: 0,
    //   w: w * 0.4,
    //   h: h * 0.8,
    //   shape: {},
    // });

    // new ShapeCell(this, {
    //   x: w * 0.4,
    //   y: 0,
    //   w: w * 0.4,
    //   h: h * 0.8,
    //   shape: {},
    // });

    // const container = new ContainerShape(this.service, {
    //   IRI: 'layout-container',
    //   literals: {
    //     descriptor: {
    //       type: 'container-shape',
    //       index: 0,
    //       cellAlignment: {
    //         x: w * 0.1,
    //         y: h * 0.1,
    //         w: w * 0.8,
    //         h: h * 0.8,
    //         align: 'center',
    //       },
    //     },
    //   },
    //   relationships: {
    //     childOf: this.IRI,
    //     shapes: {},
    //   },
    // });
  }

  get dims() {
    return [_screenX, _screenY];
  }

  remove() {
    // -- // -- //
    // Object.values(this.shapeCells).map(cell => cell.remove());
  }
}
